import {Component, Injector, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {BaseComponents} from '../../../shared/base-components';

@Component({
    selector: 'app-clients-sales',
    templateUrl: './client-sales.component.html',
    styleUrls: ['./client-sales.component.sass']
})
export class ClientSalesComponent extends BaseComponents implements OnInit {
    constructor(protected route: ActivatedRoute, protected injector: Injector) {
        super(injector);
    }
    name: string;
    async ngOnInit() {
        this.name = this.route.snapshot.queryParams.name || 'Cliente';
    }
}
